import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPersonAnonymous24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconPersonAnonymous24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14.222 11.326a4 4 0 0 1-1.472.603v.821a.75.75 0 0 1-1.5 0v-1.5a.75.75 0 0 1 .75-.75h.187A2.507 2.507 0 1 0 9.493 8H8a4 4 0 1 1 6.222 3.326M17.5 17c0-1.86-.924-3.505-2.337-4.5a5.5 5.5 0 0 0 1.114-1.042A6.99 6.99 0 0 1 19 17v3H5v-3a6.99 6.99 0 0 1 2.723-5.542c.321.397.696.748 1.114 1.042A5.5 5.5 0 0 0 6.5 17v1.5h11zm-5.5-.125a.75.75 0 0 0 .75-.75v-.75a.75.75 0 0 0-1.5 0v.75c0 .414.336.75.75.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPersonAnonymous24);
